import React from 'react';
import { pushTo } from 'helpers/routes';
import { translate } from 'helpers/intl';
import { IntlShape, injectIntl } from 'react-intl';
import messages from './messages';
import HelpBox from './helpBox';
import IsContractFoundResponse from '../IsContractFoundResponse';
import { AUTH_BY_CONTRACT } from '../constants';

export type AuthByContractFailedType = {
  intl: IntlShape;
  setSignupStep: Function;
};
const AuthByContractFailed = (props: AuthByContractFailedType) => {
  return (
    <React.Fragment>
      <IsContractFoundResponse
        nextLabel={translate({ ...messages.nextLabel }, props)}
        previousLabel={translate({ ...messages.previousLabel }, props)}
        isFound={false}
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
        onClickNext={() => {
          props.setSignupStep(AUTH_BY_CONTRACT);
        }}
        onClickPrevious={() => {
          pushTo('/');
        }}
        gridXs={5}
      >
        <HelpBox />
      </IsContractFoundResponse>
    </React.Fragment>
  );
};

export default injectIntl(AuthByContractFailed);
